import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { Flex } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'

type ConfirmAttendanceButtonProps = {
  /** The patient confirmed: the button keeps only its check and can no longer be pressed. */
  confirmed: boolean
  isLoading?: boolean
  onClick: () => void
}

/** Confirms the check-in time the hospital proposed for an admission. */
const ConfirmAttendanceButton = ({ confirmed, isLoading, onClick }: ConfirmAttendanceButtonProps) => {
  const theme = useTheme()

  return (
    <Flex>
      <Button
        variant='Primary'
        inline
        isLoading={isLoading}
        disabled={confirmed}
        onClick={onClick}
        // Once confirmed only the check shows, so the button keeps its name for a screen reader.
        aria-label={
          confirmed
            ? t({
                id: 'encounters.time-confirmed',
                comment: 'Accessible label of the confirm button once the patient confirmed the check-in time',
                message: 'Aanwezigheid bevestigd',
              })
            : undefined
        }
      >
        <Flex alignItems='center' gap={theme.UI.Spacing.Space2}>
          <FontAwesomeIcon icon={['fal', 'check']} />
          {confirmed ? null : (
            <Span type='BodyMediumRegular'>
              {t({
                id: 'encounters.time-confirm-cta',
                message: 'Bevestig je aanwezigheid',
              })}
            </Span>
          )}
        </Flex>
      </Button>
    </Flex>
  )
}

export { ConfirmAttendanceButton }
